<script lang="ts">
  import { Link } from "svelte-routing";

  const logout = () => {
    localStorage.removeItem("credentials");
  }
</script>

<div class="header">
  <h1>
    <Link to="/">
      AppName
    </Link>
  </h1>

  <nav>
    {#if localStorage.getItem("credentials")}
      <button on:click={logout}>Log Out</button>
    {:else}
      <Link to="login">Login</Link>
      <Link to="sign-up">Sign Up</Link>
    {/if}
  </nav>
</div>

<style>
  .header {
    background: black;
    color: white;
    text-transform: uppercase;
    font-size: 2em;
    font-weight: 100;
  }
</style>
